import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { TypeaheadDropdownComponent } from './components/typeahead-dropdown/typeahead-dropdown.component';
import { AutocompleteService } from './services/autocomplete.service';

@NgModule({
  declarations: [TypeaheadDropdownComponent],
  imports: [CommonModule, FormsModule],
  providers: [AutocompleteService],
  exports: [TypeaheadDropdownComponent],
})
export class AutocompleteModule {}
